<template>
	<Teleport v-for="field in fields" :key="field.uid" :to="field.anchor">
		<ListFieldControl :field="field" />
	</Teleport>
</template>

<script setup>
import { inject } from 'vue';
import ListFieldControl from '@/components/controls/ListFieldControl.vue';

const fields = inject('ecosFields');
</script>
